import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CSR_INITIATIVES } from '../mock';
import Reveal from './Reveal';

const Csr = () => {
  const navigate = useNavigate();

  const goToCsr = () => {
    navigate('/csr');
    setTimeout(() => window.scrollTo({ top: 0 }), 60);
  };

  return (
    <section id="csr" className="bg-cream py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-10">
          {/* Text block */}
          <div className="lg:col-span-4">
            <Reveal>
              <p className="mb-5 text-[10px] uppercase tracking-[0.5em] text-gold-dark">CSR</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-[0.04em] text-ink md:text-5xl">
                MUSIC
                <br />
                WITH
                <br />
                PURPOSE
              </h2>
            </Reveal>
            <Reveal delay={240}>
              <p className="mt-8 max-w-sm text-base leading-relaxed text-ink/70">
                Through KHM Cares, Kanwal is committed to creating a positive impact in communities
                across Pakistan. From supporting orphanages to enabling educational initiatives, her
                work reflects a deep belief in giving back and building a brighter future for the
                next generation.
              </p>
            </Reveal>
            <Reveal delay={340}>
              <button
                onClick={goToCsr}
                className="group mt-10 inline-flex items-center gap-3 bg-gold px-7 py-3.5 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-gold-dark hover:text-cream"
              >
                EXPLORE KHM CARES
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>

          {/* Initiative cards */}
          <div className="grid gap-8 sm:grid-cols-3 lg:col-span-8 lg:gap-6">
            {CSR_INITIATIVES.map((item, i) => (
              <Reveal key={item.id} delay={i * 130}>
                <div className="group cursor-pointer" onClick={goToCsr}>
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/15" />
                  </div>
                  <h3 className="mt-5 text-[11px] tracking-[0.3em] text-ink">{item.title}</h3>
                  <p className="mt-2 text-[11px] leading-relaxed text-ink/55">{item.tagline}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Csr;
